import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { BrowserStorageService } from '../common/browser-storage.service';

@Injectable({
  providedIn: 'root',
})
export class NetworkService {
  private onlineStatusSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  private wasOffline = false; // Tracks if the app was offline

  constructor(
    private _storageService: BrowserStorageService,
    private _ngZone: NgZone,
  ) {
    if (this._storageService.getBrowser()) this.listenForNetworkChanges();
  }

  private listenForNetworkChanges(): void {
    window.addEventListener('offline', () => {
      this.wasOffline = true; // Mark app as offline
      this.updateOnlineStatus(false);
    });

    window.addEventListener('online', () => {
      this.updateOnlineStatus(true);

      if (this.wasOffline) {
        this.wasOffline = false; // Reset flag to prevent multiple refreshes
        this._ngZone.run(() => {
          location.reload(); // Reload the app when it comes back online
        });
      }
    });
  }

  private updateOnlineStatus(status: boolean): void {
    this._ngZone.run(() => this.onlineStatusSubject.next(status));
  }

  get getNetworkStatus$(): Observable<boolean> {
    return this.onlineStatusSubject.asObservable();
  }

  /** ✅ Returns the current network status (true = online, false = offline) */
  isOnline(): boolean {
    return this.onlineStatusSubject.value;
  }
}
